const BASE_URL: string = process.env.NEXT_PUBLIC_API_URL ?? '';
const COMMON: string = '/api/v1/';

const config = {
   BASE_URL,
   API_URL: `${BASE_URL}${COMMON}`,
   STRIPE_PUBLISHABLE_API_KEY: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_API_KEY ?? '',
   WP_URL: process.env.NEXT_PUBLIC_WP_URL ?? '',
};
export default config;
